import { Link } from "react-router-dom";

// components
import { Alert } from "@trussworks/react-uswds";

// styles
import styles from "./NotListedPage.module.scss";

export default function NotListedPage({ businessName }: { businessName: string }) {

  return (
    <>
      <div className={styles["not-listed-root"]}>
        <h1 className={styles["title"]}>
          Edit {businessName}
        </h1>
        <Alert
          type={"warning"}
          headingLevel={"h4"}
          className={styles["alert-wrapper"]}
        >
          <p>
            <b>This business is not found in our list of Small Businesses</b>
          </p>
          <p>
            See <Link to="https://sbaone.atlassian.net/wiki/external/NTU0Yjk4YmQxOWZlNGJlNjg5ZjQ4YjQzYjU1ZDE0MmI" rel="noopener noreferrer" target="_blank">here</Link> for some possible reasons why.
          </p>
        </Alert>
      </div>
    </>
  );
}